import { render, staticRenderFns } from "./PatientAlertList.vue?vue&type=template&id=368d7e62&"
import script from "./PatientAlertList.vue?vue&type=script&lang=js&"
export * from "./PatientAlertList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports